export enum Colors {
    Error = "#F54563",
    Information = "#8FA0F2",
    Success = "#24A6BB",
    Primary = "#24A6BB",
    PrimaryColor = "#0D0D0D"
}
